import { useEffect } from "react";
import RadarMap from "@/components/RadarMap";
import AgencyPlacer from "@/components/AgencyPlacer";
import PositionCard from "@/components/zones/PositionCard";
import Podium from "@/components/zones/Podium";
import Zones from "@/components/zones/Zones";
import { track } from "@/lib/api";

const focusAgency = () => {
  const el = document.querySelector('[data-testid="agency-input"]');
  if (!el) return;
  el.scrollIntoView({ behavior: "smooth", block: "center" });
  el.focus({ preventScroll: true });
};

export const mapProps = (data, onUnlock) => ({
  radarId: data.radar_id,
  markers: data.map?.markers || [],
  dots: data.map?.dots || [],
  cards: data.top10 || data.top3 || [],
  unlocked: !!data.owned,
  onLocked: () => {
    track("unlock_interest", { target: "grey_dot", radar_id: data.radar_id });
    onUnlock?.();
  },
  version: data.map_version,
});

export default function RadarResult({ data, onUnlock, showPlacer = false, onPlaced, withMap = true, audit = null, visibility = null, compact = false, animateUnlock = false, inApp = false }) {
  const placing = showPlacer && data.user?.status !== "found";
  useEffect(() => {
    if (withMap && data.radar_id) track("result_displayed", { radar_id: data.radar_id });
  }, [withMap, data.radar_id]);
  return (
    <div data-testid="radar-result" className="fade-up flex flex-col gap-4 md:gap-6">
      {withMap && (
        <div className="-mx-5 md:mx-0">
          <RadarMap {...mapProps(data, onUnlock)} />
        </div>
      )}
      {placing ? <AgencyPlacer radarId={data.radar_id} onPlaced={onPlaced} onUnlock={onUnlock} /> : <PositionCard u={data.user} query={data.query} visibility={visibility} inApp={inApp} />}
      <Podium data={data} onPlace={focusAgency} />
      {!compact && <Zones key={data.radar_id} data={data} onUnlock={onUnlock} audit={audit} animate={animateUnlock} />}
    </div>
  );
}
